import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../alert/Alert.css';
import './AppSupport.css';
import appConfig from '../../config';

/**
 * Shows application version details and release notes guidance for the School Engine web app.
 */
export default function AppSupportAbout() {
    const navigate = useNavigate();

    return (
        <div className="alert-home-container">
            <div className="appsupport-top-actions">
                <button
                    type="button"
                    className="appsupport-return-button"
                    onClick={() => navigate('/app/support')}
                >
                    Return to Support Home
                </button>
            </div>

            <div className="alert-home-card appsupport-about-card">
                <div className="appsupport-about-header">
                    <div>
                        <h1 className="alert-home-heading" style={{ textAlign: 'left' }}>Web App Version Information</h1>
                        <p className="alert-home-body alert-home-subhead" style={{ textAlign: 'left' }}>
                            Review the current School Engine web app version, build details, and release note status.
                        </p>
                    </div>
                </div>

                <div className="appsupport-about-grid">
                    <section className="appsupport-about-panel">
                        <h2 className="appsupport-about-panel-title">Version Information</h2>
                        <div className="appsupport-about-kv-list">
                            <div className="appsupport-about-kv-row">
                                <span className="appsupport-about-kv-label">App Version</span>
                                <span className="appsupport-about-kv-value">{appConfig.APP_VERSION_NUMBER}</span>
                            </div>
                            <div className="appsupport-about-kv-row">
                                <span className="appsupport-about-kv-label">Build Date</span>
                                <span className="appsupport-about-kv-value">{appConfig.BUILD_DATE}</span>
                            </div>
                        </div>
                    </section>

                    <section className="appsupport-about-panel">
                        <h2 className="appsupport-about-panel-title">Current Version Notes</h2>
                        <ul className="appsupport-about-list">
                            <li className="appsupport-about-list-item">New Time Slot Bookings available for all users with the Bookings module.</li>
                            <li className="appsupport-about-list-item">All Booking types now supported on mobile devices.</li>
                            <li className="appsupport-about-list-item">Redesigned Sidebar with profile area.</li>
                            <li className="appsupport-about-list-item">New Profile page allows for updating your profile picture and adding an MFA Device, or changing your password.</li>
                            <li className="appsupport-about-list-item">OnCall module audio alerts for pending calls have been fixed with the addition of an allow audio button on page load.</li>
                            <li className="appsupport-about-list-item">Upgraded the support system to include documentation, support requests and web app version information.</li>
                        </ul>
                    </section>
                </div>
            </div>
        </div>
    );
}
